/*eslint-disable*/ module.exports = { messages: { Settings: 'Settings' } }
